import { useLocation } from 'react-router-dom';
import { ProfileAnnouncement } from './ProfileAnnouncement';
import { PaymentAnnouncement } from './PaymentAnnouncement';
import { AddressAnnouncement } from './AddressAnnouncement';
import { PasskeyAnnouncement } from './PasskeyAnnouncement';
import { INNER_ROUTES } from '../../../constants';

type NotificationSystemProps = {
  currentNotification:
    | 'profile'
    | 'payment'
    | 'address'
    | 'passkey'
    | undefined;
  onClose: () => void;
};
export const NotificationSystem = ({
  currentNotification,
  onClose,
}: NotificationSystemProps) => {
  const location = useLocation().pathname;

  return (
    <>
      {currentNotification === 'profile' &&
        !location.includes(INNER_ROUTES.SETTINGS) && (
          <ProfileAnnouncement onClose={onClose} />
        )}
      {currentNotification === 'payment' &&
        !location.includes(INNER_ROUTES.PAYMENT_METHODS) && (
          <PaymentAnnouncement onClose={onClose} />
        )}
      {currentNotification === 'address' &&
        !location.includes(INNER_ROUTES.ADDRESSES) && (
          <AddressAnnouncement onClose={onClose} />
        )}
      {currentNotification === 'passkey' &&
        !location.includes(INNER_ROUTES.PASSKEYS) && (
          <PasskeyAnnouncement onClose={onClose} />
        )}
    </>
  );
};
